import { get, map, omit } from 'lodash';
import React from 'react';
import {
    CONTRACT_STATE_DRAFT,
    CONTRACT_STATE_FEEDBACK,
    CONTRACT_STATE_REMINDER_SENT,
    CONTRACT_STATE_SENT,
    CONTRACT_STATE_SENT_DRAFT,
    CONTRACT_STATE_SIGNED
} from '../../../../constants/settings';
import { msToTime } from '../../../../lib/date.utils';

const Activity = ({ activity = [], contractId, data = {} }) => {
    const _userName = act => get(act, 'user.fullName') || get(act, 'anonName', '');
    const activityToText = act => {
        switch (act.state) {
            case CONTRACT_STATE_SIGNED:
                return `${act.isUpload ? 'Signed version uploaded' : 'Signed'} by ${data.signedBy || _userName(act)}`;
            case CONTRACT_STATE_SENT:
                return `${act.isUpload ? 'Sent version uploaded' : 'Sent version'} by ${get(act, 'user.fullName', '')}`;
            case CONTRACT_STATE_DRAFT:
            case CONTRACT_STATE_SENT_DRAFT:
                return `Draft ${act.isUpload ? 'uploaded' : 'saved'} by ${get(act, 'user.fullName', '')}`;
            case CONTRACT_STATE_FEEDBACK:
                const byWho = get(act, 'user.fullName', '')
                    ? ` by ${get(act, 'user.fullName', '')}`
                    : get(act, 'anonName')
                      ? ` by ${get(act, 'anonName')}<${get(act, 'anonEmail')}>`
                      : '';
                return `Feedback${byWho}`;
            case CONTRACT_STATE_REMINDER_SENT:
                return `Reminder sent by ${act.user}`;
            default:
                return act.state;
        }
    };
    const activityToComment = act => {
        switch (act.state) {
            case CONTRACT_STATE_SIGNED:
                return act.isUpload ? get(act, 'comments.admin', 'No comments') : '';
            case CONTRACT_STATE_SENT:
                return get(act, 'comments.admin', 'No comments');
            case CONTRACT_STATE_FEEDBACK:
                const omitAdmin = omit(act.comments || {}, ['admin']);
                return map(omitAdmin, (v, i) => <p key={`${i}-${v}`}>{v}</p>);
            case CONTRACT_STATE_REMINDER_SENT:
                return `${act.comments}`;
            default:
                return '';
        }
    };
    if (contractId) {
        return (
            <aside className="ckp-contracts-editor-aside">
                <h4 className="ckp-contracts-editor-aside-title">Activity</h4>
                <ul className="ckp-contracts-editor-aside-list">
                    {activity.map(a => (
                        <li
                            key={a.id}
                            className={`ckp-contracts-editor-aside-item u-bold ckp-contracts-editor-aside-${a.state.replace(
                                '_',
                                '-'
                            )}`}
                        >
                            <span>{activityToText(a)}</span>
                            <span className="ckp-contracts-editor-aside-date">{msToTime(a.createdAt, true)}</span>
                            <span className="ckp-contracts-editor-aside-comments">{activityToComment(a)}</span>
                        </li>
                    ))}
                </ul>
            </aside>
        );
    } else {
        return <aside className="ckp-contracts-editor-aside is-empty" />;
    }
};

export default Activity;
